'use strict';

// Enhances the desktop primary nav dropdowns for keyboard and screen reader
// users. Hover behaviour is handled in CSS; this layer adds the .is-open class
// used by CSS to reveal submenus on focus, keeps aria-expanded in sync, and
// supports Escape to dismiss.
const initDesktopNav = () => {
    const parents = document.querySelectorAll('.site-nav .menu-item-has-children');
    if (!parents.length) return;

    parents.forEach(parent => {
        const link = parent.querySelector(':scope > a');
        const submenu = parent.querySelector(':scope > .sub-menu');
        if (!link || !submenu) return;

        link.setAttribute('aria-haspopup', 'true');
        link.setAttribute('aria-expanded', 'false');

        // When a submenu item is the current page, expose that to AT up front.
        const open = () => {
            parent.classList.add('is-open');
            link.setAttribute('aria-expanded', 'true');
        };

        const close = () => {
            parent.classList.remove('is-open');
            link.setAttribute('aria-expanded', 'false');
        };

        // Guards against the focusin that fires when Escape returns focus to the
        // parent link from immediately re-opening the menu.
        let escClosed = false;

        parent.addEventListener('focusin', () => {
            if (escClosed) return;
            open();
        });

        parent.addEventListener('focusout', event => {
            // Only close once focus has left the whole menu item.
            if (parent.contains(event.relatedTarget)) return;
            escClosed = false;
            close();
        });

        parent.addEventListener('keydown', event => {
            if (event.key !== 'Escape') return;
            if (!parent.classList.contains('is-open')) return;
            escClosed = true;
            close();
            link.focus();
        });
    });
};

export default initDesktopNav;
